import React, { useEffect, useState } from "react";
import { CrudModal } from "../../components/_index";
import { Formik, Form, Field } from "formik";
import Grid from "@mui/material/Grid2";
import { Typography, Button, Box, Checkbox } from "@mui/material";
import { AutoComplete, DatePicker } from "../../components/_index";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/Reducer/toastReducer";
import {
  getCategory,
  postCategory,
  updateCategory,
} from "../../services/category.service";
import { FileUploader } from "react-drag-drop-files";

import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { updateTicket } from "../../services/ticket.service";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { getSpecificUser, getUser } from "../../services/user.service";
const ViewTicket = ({
  handleCloseDrawer,
  formType,
  selectedData,
  setOpenDrawer,
  GetTicketData,
}) => {
  const dispatch = useDispatch();
  const disabled = formType === "edit";
  const [categoryData, setCategoryData] = useState([]);
  const [userData, setUserData] = useState([]);
  console.log(userData, "SUD");
  const [initialValues, setInitialValues] = useState({
    categoryId: "",
    subject: "",
    message: "",
    assignedTo: "",
    file: [],
  });

  console.log(selectedData, "SD");
  const [checked, setChecked] = useState(false);
  const validationSchema = yup.object().shape({
    categoryId: yup.string().required("Category Required *"),
    subject: yup.string().required("Enter the subject *"),
    message: yup.string().required("Enter the message *"),
    assignedTo: yup.string().required("Select the Assignee"),
  });

  useEffect(() => {
    if (formType === "edit" || formType === "view") {
      setInitialValues({
        ticketId: selectedData?.ticketId || "",
        createdAtDate: selectedData?.createdAtDate || "",
        ticketCreatedName: selectedData?.createdByName || "",
        ticketCreatedEmail: selectedData?.createdByEmail || "",
        categoryId: selectedData?.categoryId || "",
        assignedTo: selectedData?.assignedTo || "",
        subject: selectedData.subject || "",
        message: selectedData.message || "",
      });
    }
  }, [formType, selectedData]);

  React.useEffect(() => {
    getCategory().then((res) => {
      const modifiedData = res.data.map((el) => ({
        ...el,
        label: el?.name,
      }));
      setCategoryData(modifiedData);
    });
  }, []);

  useEffect(() => {
    getSpecificUser().then((res) => {
      const modifiedData = (res?.data || []).map((el) => ({
        ...el,
        label: `${el?.name}  (${el?.roleData?.name})`,
      }));
      setUserData(modifiedData);
    });
  }, []);

  const [fileName, setFileName] = useState(
    selectedData.documentFile ? selectedData?.documentFile?.fileName : ""
  );

  const voiceName = selectedData?.voiceFile?.fileName;
  //   const maxLength = 15; // Adjust the maximum length to your preference
  //   const shortenedName =
  //     voiceName && voiceName.length > maxLength
  //       ? voiceName.substring(0, maxLength) + "..."
  //       : voiceName;

  const handleFileChange = (e, file, setFieldValue) => {
    if (e && e.name) {
      const selectedFile = e;
      setFileName(selectedFile.name);
      setFieldValue(file, selectedFile);
    }
  };

  const onSubmit = async (values) => {
    try {
      // const formWithManager = {
      //   ...values,
      //   isManagement: checked,
      // };

      const formData = new FormData();

      formData.append("values", JSON.stringify(values));
      if (values.file) {
        formData.append("file", values.file);
      }

      const apiMethod =
        formType === "edit"
          ? updateTicket(selectedData._id, formData)
          : postCategory(formData);
      const res = await apiMethod;
      setOpenDrawer(false);
      GetTicketData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      dispatch(showToast({ message: error.data.message, type: "error" }));
    }
  };

  return (
    <CrudModal
      title={
        // formType === "add"
        //   ? "Create Ticket"
        //   : formType === "edit"
        //   ? "Edit Ticket"
        //   : "View Ticket"
        "Assignee"
      }
      open={true}
      handleClose={handleCloseDrawer}
      maxWidth="md"
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ touched, errors, setFieldValue, values }) => (
          <div className="formContainer" style={{ height: "fit-content" }}>
            <Form>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Ticket ID
                  </Typography>
                  <Field
                    name="ticketId"
                    className="InputField"
                    placeholder="Enter Category"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.ticketId && errors.ticketId
                      ? errors.ticketId
                      : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Created AT
                  </Typography>
                  <Field
                    name="createdAtDate"
                    className="InputField"
                    placeholder="Enter Category"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.createdAtDate && errors.createdAtDate
                      ? errors.createdAtDate
                      : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Creator's Name
                  </Typography>
                  <Field
                    name="ticketCreatedName"
                    className="InputField"
                    placeholder="Enter Category"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.ticketCreatedName && errors.ticketCreatedName
                      ? errors.ticketCreatedName
                      : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Creator's Email
                  </Typography>
                  <Field
                    name="ticketCreatedEmail"
                    className="InputField"
                    placeholder="Enter Created Email"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.ticketCreatedEmail && errors.ticketCreatedEmail
                      ? errors.ticketCreatedEmail
                      : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Category
                  </Typography>
                  <AutoComplete
                    disabled={disabled}
                    onChange={(e, v) => setFieldValue("categoryId", v?._id)}
                    options={categoryData}
                    placeholder="Select Category"
                    value={values?.categoryId}
                  />
                  <div className="form-error">
                    {touched.categoryId && errors.categoryId
                      ? errors.categoryId
                      : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Mode
                  </Typography>
                  <Field
                    name="mode"
                    className="InputField"
                    placeholder="Enter Mode"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.mode && errors.mode ? errors.mode : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Subject
                  </Typography>
                  <Field
                    name="subject"
                    className="InputField"
                    placeholder="Enter Subject"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.subject && errors.subject ? errors.subject : null}
                  </div>
                </Grid>

                <Grid size={{ xs: 12, sm: 12 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Message
                  </Typography>
                  <Field
                    // disabled={disabled}
                    name="message"
                    as="textarea"
                    className="InputField"
                    style={{ height: "100px" }}
                    placeholder="Write your message here"
                  />
                  <div className="form-error">
                    {touched.message && errors.message ? errors.message : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Name of the Assignee
                  </Typography>
                  <AutoComplete
                    options={userData}
                    clearIcon={false}
                    value={values?.assignedTo}
                    onChange={(e, v) => {
                      setFieldValue("assignedTo", v ? v._id : null);
                    }}
                    placeholder="Select user to assign"
                  />
                  <div className="form-error">
                    {touched.assignedTo && errors.assignedTo
                      ? errors.assignedTo
                      : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }} className="File-Upload">
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    File
                  </Typography>
                  <FileUploader
                    disabled={disabled}
                    name="file"
                    handleChange={(e) =>
                      handleFileChange(e, "file", setFieldValue)
                    }
                    multiple={false}
                  />
                  <Box className="uploadIcon">
                    <React.Fragment>
                      <CloudUploadOutlinedIcon className="cloud-icon" />
                      {fileName
                        ? fileName
                        : "Drag & Drop or click to upload files"}
                    </React.Fragment>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography
                    className="InputTitle"
                    sx={{ marginBottom: "-2px" }}
                  >
                    &nbsp;
                  </Typography>
                  {selectedData?.documentFile && (
                    <RemoveRedEyeIcon
                      sx={{
                        padding: "6px",
                        border: "1px solid #D5D7E8",
                        borderRadius: "5px",
                        color: "#00675D",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        selectedData?.documentFile?.fileURL &&
                        window.open(selectedData?.documentFile?.fileURL)
                      }
                    />
                  )}
                </Grid>
                <Grid size={{ xs: 12 }} mt={2}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "20px",
                    }}
                  >
                    <Button
                      className="cancelButton"
                      onClick={() => setOpenDrawer(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      className="addButton"
                      // sx={{ display: formType === "view" ? "none" : "flex" }}
                    >
                      {formType === "edit" ? "Update" : "Save"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </div>
        )}
      </Formik>
    </CrudModal>
  );
};

export default ViewTicket;
